module.exports = __webpack_public_path__ + "img/ICONO9.d5acfdad.png";